import styled from 'styled-components';

export interface AbsoluteImageProps {
  top?: number;
  left?: number;
  right?: number;
  bottom?: number;
  cursor?: string;
}

export const AbsoluteImage = styled.img<AbsoluteImageProps>`
  position: absolute;
  top: ${({ top }) => `${top}px` || '0'};
  left: ${({ left }) => `${left}px` || '0'};
  right: ${({ right }) => `${right}px` || '0'};
  bottom: ${({ bottom }) => `${bottom}px` || '0'};
  cursor: ${({ cursor }) => `${cursor}` || 'unset'};
`;
